import { render, staticRenderFns } from "./basicDialog.vue?vue&type=template&id=74413756&scoped=true"
import script from "./basicDialog.vue?vue&type=script&lang=js"
export * from "./basicDialog.vue?vue&type=script&lang=js"
import style0 from "./basicDialog.vue?vue&type=style&index=0&id=74413756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74413756",
  null
  
)

export default component.exports